import {
	faCalendar,
	faMapLocation,
	faPhone,
	faSchool,
	faSuitcase,
	faUser,
	faVenusMars,
} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import {
	ANCHAL,
	DOB_YEAR,
	EDUCATION,
	GENDER,
	STATE_DANGER,
	STATE_DEFAULT,
	TOAST_STATE_DANGER,
	USER_STATUS,
} from "../../utils/constants";
import Badge from "../DesignSystem/Badge/Badge";
import Button from "../DesignSystem/Button/Button";
import CustomInput from "../DesignSystem/CustomInput/CustomInput";
import Dropdown from "../DesignSystem/Dropdown/Dropdown";
import * as moment from "moment";
import { showToast } from "../../store/thunks/toasts";
import { fetchRegisteredUsers, updatedRegisteredUser } from "../../store/thunks/registrations";
import Webcam from "react-webcam";
import Checkbox from "../DesignSystem/Checkbox/Checkbox";

let formState = {
	firstName: true,
	lastName: true,
	fatherName: true,
	dob: true,
	phoneNumber: true,
	photo: true,
	gender: true,
	city: true,
	state: true,
	address: true,
	pincode: true,
	anchal: true,
	education: true,
	occupation: true,
	spiritualLevel: true,
};

const EditUserDetailsPopup = ({
	id,
	regNumber,
	photo,
	firstName,
	lastName,
	fathersName,
	mobileNumber,
	gender,
	dob,
	approvalStatus,
	city,
	state,
	region,
	address,
	pinCode,
	education,
	occupation,
	onFinish,
	onClose,
	knowledgeStatus,
}) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [editedFirstName, setEditedFirstName] = useState(firstName);
	const [editedFirstNameInputState, setEditedFirstNameInputState] = useState("");
	const [editedFirstNameError, setEditedFirstNameError] = useState("");

	const [editedLastName, setEditedLastName] = useState(lastName);
	const [editedLastNameInputState, setEditedLastNameInputState] = useState("");
	const [editedLastNameError, setEditedLastNameError] = useState("");

	const [editedFatherName, setEditedFatherName] = useState(fathersName);
	const [editedFatherNameInputState, setEditedFatherNameInputState] = useState("");
	const [editedFatherNameError, setEditedFatherNameError] = useState("");

	const [editedPhoneNumber, setEditedPhoneNumber] = useState(mobileNumber);
	const [editedPhoneNumberError, setEditedPhoneNumberError] = useState("");
	const [editedPhoneNumberInputState, setEditedPhoneNumberInputState] = useState("");

	const [genderOptions, setGenderOptions] = useState("");
	const [editedGender, setEditedGender] = useState("");
	const [editedGenderError, setEditedGenderError] = useState("");
	const [editedGenderInputState, setEditedGenderInputState] = useState("");

	const [editedDob, setEditedDob] = useState(dob);
	const [editedDobError, setEditedDobError] = useState("");
	const [editedDobInputState, setEditedDobInputState] = useState("");

	const [editedCity, setEditedCity] = useState(city);
	const [editedCityInputState, setEditedCityInputState] = useState("");
	const [editedCityError, setEditedCityError] = useState("");

	const [editedState, setEditedState] = useState(state);
	const [editedStateInputState, setEditedStateInputState] = useState("");
	const [editedStateError, setEditedStateError] = useState("");

	const [editedAddress, setEditedAddress] = useState(address);
	const [editedAddressInputState, setEditedAddressInputState] = useState("");
	const [editedAddressError, setEditedAddressError] = useState("");

	const [editedPincode, setEditedPincode] = useState(pinCode);
	const [editedPincodeInputState, setEditedPincodeInputState] = useState("");
	const [editedPincodeError, setEditedPincodeError] = useState("");

	const [editedAnchal, setEditedAnchal] = useState(region);
	const [editedAnchalInputState, setEditedAnchalInputState] = useState("");
	const [editedAnchalError, setEditedAnchalError] = useState("");

	const [editedEducation, setEditedEducation] = useState(education);
	const [editedEducationInputState, setEditedEducationInputState] = useState("");
	const [editedEducationError, setEditedEducationError] = useState("");

	const [editedOccupation, setEditedOccupation] = useState(occupation);
	const [editedOccupationInputState, setEditedOccupationInputState] = useState("");
	const [editedOccupationError, setEditedOccupationError] = useState("");

	const [spiritualLevel, setSpiritualLevel] = useState(1);
	const [spiritualLevelState, setSpiritualLevelState] = useState("");
	const [spiritualLevelError, setSpiritualLevelError] = useState("");

	const webcamRef = useRef(null);
	const [webcamImage, setWebcamImage] = useState(null);
	const [isPhotoCaptured, setIsPhotoCaptured] = useState(false);
	const [isTakingPicture, setIsTakingPicture] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(true);

	const firstNameInput = useRef();
	const lastNameInput = useRef();
	const fatherNameInput = useRef();
	const dobInput = useRef();
	const phoneNumberInput = useRef();
	const genderInput = useRef();
	const anchalInput = useRef();
	const cityInput = useRef();
	const stateInput = useRef();
	const addressInput = useRef();
	const pincodeInput = useRef();
	const educationInput = useRef();
	const occupationInput = useRef();
	const spiritualOptions1Ref = useRef();
	const spiritualOptions2Ref = useRef();
	const spiritualOptions3Ref = useRef();

	useEffect(() => {
		let genderOptions = [];

		GENDER.forEach((gen) => {
			genderOptions.push(formatMessage({ id: `public.${gen.label}` }));
		});

		setGenderOptions(genderOptions);
		setEditedGender(gender);
	}, []);

	useEffect(() => {
		spiritualOptions1Ref.current.checked = true;

		if (knowledgeStatus === 2 || knowledgeStatus === 3) {
			spiritualOptions2Ref.current.checked = true;
		}

		if (knowledgeStatus === 4 || knowledgeStatus === 5) {
			spiritualOptions3Ref.current.checked = true;
		}

		if (knowledgeStatus === 6 || knowledgeStatus === 7) {
			spiritualOptions2Ref.current.checked = true;
			spiritualOptions3Ref.current.checked = true;
		}
	}, [knowledgeStatus]);

	const getBadgeTypeByStatus = () => {
		let kind = "";

		if (approvalStatus === USER_STATUS.APPROVED) {
			kind = "badge-success";
		} else if (approvalStatus === USER_STATUS.REJECTED) {
			kind = "badge-danger";
		} else {
			kind = "badge-yellow";
		}

		return kind;
	};

	const onClickImageUpdate = () => {
		setIsTakingPicture(true);
	};

	const retakePhoto = () => {
		setIsPhotoCaptured(false);
		setIsTakingPicture(true);
	};

	const capturePhoto = () => {
		const imageSrc = webcamRef.current.getScreenshot();
		setWebcamImage(imageSrc);
		setIsPhotoCaptured(true);
		formState.photo = imageSrc ? true : false;
	};

	const validateField = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formState[stateKey] = false;
		} else {
			setButtonDisabled(false);
			formState[stateKey] = true;
		}

		return isError;
	};

	const handleFirstNameChange = () => {
		setEditedFirstNameError("");
		const state = validateField(
			firstNameInput.current.value,
			setEditedFirstNameError,
			"public.firstname.error",
			"firstName"
		);
		setEditedFirstNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedFirstName(firstNameInput.current.value);

		return state;
	};

	const handleLastNameChange = () => {
		setEditedLastNameError("");
		const state = validateField(
			lastNameInput.current.value,
			setEditedLastNameError,
			"public.lastname.error",
			"lastName"
		);
		setEditedLastNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedLastName(lastNameInput.current.value);

		return state;
	};

	const handleFatherNameChange = () => {
		setEditedFatherNameError("");
		const state = validateField(
			fatherNameInput.current.value,
			setEditedFatherNameError,
			"public.fathername.error",
			"fatherName"
		);
		setEditedFatherNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedFatherName(fatherNameInput.current.value);

		return state;
	};

	const validatePhoneNumber = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		} else if (inputValue.length !== 10) {
			onError(formatMessage({ id: "public.phonenumber.invalid" }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formState[stateKey] = false;
		} else {
			setButtonDisabled(false);
			formState[stateKey] = true;
		}

		return isError;
	};

	const handlePhoneNumberChange = () => {
		setEditedPhoneNumberError("");
		const state = validatePhoneNumber(
			phoneNumberInput.current.value,
			setEditedPhoneNumberError,
			"public.phonenumber.error",
			"phoneNumber"
		);
		setEditedPhoneNumberInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedPhoneNumber(phoneNumberInput.current.value);

		return state;
	};

	const validateDob = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		} else if (moment().diff(inputValue, "years") < DOB_YEAR) {
			onError(formatMessage({ id: "public.dob.ageLimitError" }, { year: DOB_YEAR }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formState[stateKey] = false;
		} else {
			setButtonDisabled(false);
			formState[stateKey] = true;
		}

		return isError;
	};

	const handleDobChange = () => {
		setEditedDobError("");
		const state = validateDob(dobInput.current.value, setEditedDobError, "public.dob.error", "dob");
		setEditedDobInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedDob(moment().unix(dobInput.current.value));

		return state;
	};

	const handleGenderInputChange = () => {
		setEditedGenderError("");
		const state = validateField(genderInput.current.value, setEditedGenderError, "public.gender.error", "gender");
		setEditedGenderInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedGender(genderInput.current.value);

		return state;
	};

	const handleAnchalChange = (value) => {
		setEditedAnchalError("");
		const state = validateField(anchalInput.current.value, setEditedAnchalError, "public.anchal.error", "anchal");
		setEditedAnchalInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedAnchal(anchalInput.current.value);

		return state;
	};

	const handleCityChange = () => {
		setEditedCityError("");
		const state = validateField(cityInput.current.value, setEditedCityError, "public.city.error", "city");
		setEditedCityInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedCity(cityInput.current.value);

		return state;
	};

	const handleStateChange = () => {
		setEditedStateError("");
		const state = validateField(stateInput.current.value, setEditedStateError, "public.state.error", "state");
		setEditedStateInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedState(stateInput.current.value);

		return state;
	};

	const handleAddressChange = () => {
		setEditedAddressError("");
		const state = validateField(
			addressInput.current.value,
			setEditedAddressError,
			"public.address.error",
			"address"
		);
		setEditedAddressInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedAddress(addressInput.current.value);

		return state;
	};

	const handlePincodeChange = () => {
		setEditedPincodeError("");
		const state = validateField(
			pincodeInput.current.value,
			setEditedPincodeError,
			"public.pincode.error",
			"pincode"
		);
		setEditedPincodeInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedPincode(pincodeInput.current.value);

		return state;
	};

	const handleEducationChange = () => {
		setEditedEducationError("");
		const state = validateField(
			educationInput.current.value,
			setEditedEducationError,
			"public.education.error",
			"education"
		);
		setEditedEducationInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedEducation(educationInput.current.value);

		return state;
	};

	const handleSpiritualChange = (e) => {
		let bitNumber = 1;

		if (spiritualOptions2Ref.current.checked) {
			bitNumber = 2;
		}

		if (spiritualOptions3Ref.current.checked) {
			bitNumber = 4;
		}

		if (spiritualOptions1Ref.current.checked && spiritualOptions2Ref.current.checked) {
			bitNumber = 3;
		}

		if (spiritualOptions1Ref.current.checked && spiritualOptions3Ref.current.checked) {
			bitNumber = 5;
		}

		if (spiritualOptions2Ref.current.checked && spiritualOptions3Ref.current.checked) {
			bitNumber = 6;
		}

		if (
			spiritualOptions1Ref.current.checked &&
			spiritualOptions2Ref.current.checked &&
			spiritualOptions3Ref.current.checked
		) {
			bitNumber = 7;
		}

		if (
			spiritualOptions1Ref.current.checked ||
			spiritualOptions2Ref.current.checked ||
			spiritualOptions3Ref.current.checked
		) {
			formState.spiritualLevel = true;
			setSpiritualLevelState(STATE_DEFAULT);
			setSpiritualLevel(bitNumber);
			setSpiritualLevelError("");
			setButtonDisabled(false);
		} else {
			formState.spiritualLevel = false;
			setSpiritualLevelState(STATE_DANGER);
			setSpiritualLevel("");
			setSpiritualLevelError(formatMessage({ id: "public.spiritual.error" }));
			setButtonDisabled(true);
		}
	};

	const handleOccupationChange = () => {
		setEditedOccupationError("");
		const state = validateField(
			occupationInput.current.value,
			setEditedOccupationError,
			"public.occupation.error",
			"occupation"
		);
		setEditedOccupationInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setEditedOccupation(occupationInput.current.value);

		return state;
	};

	const onClickUpdateUser = async () => {
		if (Object.values(formState).filter((value) => !value).length !== 0) {
			dispatch(showToast({ message: "public.generic.error", type: TOAST_STATE_DANGER }));
			return;
		}

		const payload = {
			id,
			firstName: editedFirstName,
			lastName: editedLastName,
			fathersName: editedFatherName,
			dob: editedDob,
			mobileNumber: editedPhoneNumber,
			photo: webcamImage,
			gender: editedGender,
			city: editedCity,
			state: editedState,
			address: editedAddress,
			pinCode: editedPincode,
			region: editedAnchal,
			knowledgeStatus: spiritualLevel,
			education: editedEducation,
			occupation: editedOccupation,
		};

		const updateUserResponse = await dispatch(updatedRegisteredUser(payload));
		if (updateUserResponse) {
			dispatch(
				showToast({
					message: "registration.user.updateSuccess",
				})
			);
			await dispatch(fetchRegisteredUsers());
			onFinish();
		} else {
			dispatch(
				showToast({
					message: "registration.user.updateFailed",
					type: TOAST_STATE_DANGER,
				})
			);
			onFinish();
		}
	};

	return (
		<div className="user-details flex direction-col align-items-start">
			<div className="text text-body--5 text-left text-disabled">{regNumber}</div>
			<div className="flex direction-row align-items-center">
				{isPhotoCaptured ? (
					<div className="flex direction-row align-items-center">
						<img src={webcamImage} className="webcam-image" alt="webcam-captured-image" />
					</div>
				) : isTakingPicture ? (
					<div className="flex direction-row align-items-center">
						<Webcam ref={webcamRef} audio={false} screenshotFormat="image/jpeg" />
						<Button
							className="button-secondary button-md ml-16"
							label="public.action.capturePhoto"
							onClick={capturePhoto}
						/>
					</div>
				) : (
					<>
						<div style={{ cursor: "pointer" }} onClick={onClickImageUpdate}>
							<img id="edit-image" src={photo} alt="user-avatar" />
							<div className="image-overlay"></div>
						</div>
					</>
				)}

				<div className="text text-header--7 text-left ml-8">{`${editedFirstName} ${editedLastName}`}</div>
				<Badge className="ml-8" label={approvalStatus} kind={getBadgeTypeByStatus()} />
			</div>

			<div className="row mt-16">
				<div className="text text-body--3 text-bold text-left mb-8 popup-section-title">
					{formatMessage({ id: "registration.section.personalDetails" })}
				</div>
				<div className="row">
					<div className="col-12">
						<CustomInput
							id="firstname"
							label="public.firstname"
							icon={faUser}
							isMandatory={true}
							placeholder="public.firstname.placeholder"
							ref={firstNameInput}
							state={editedFirstNameInputState}
							value={editedFirstName}
							onChange={handleFirstNameChange}
							style={{ width: "100%" }}
						/>
						{editedFirstNameError && (
							<div className="text text-body--5 text-left text-danger">{editedFirstNameError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="lastname"
							label="public.lastname"
							icon={faUser}
							isMandatory={true}
							placeholder="public.lastname.placeholder"
							ref={lastNameInput}
							state={editedLastNameInputState}
							value={editedLastName}
							onChange={handleLastNameChange}
							style={{ width: "100%" }}
						/>
						{editedLastNameError && (
							<div className="text text-body--5 text-left text-danger">{editedLastNameError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="fathername"
							label="public.fathername"
							icon={faUser}
							isMandatory={true}
							placeholder="public.fathername.placeholder"
							ref={fatherNameInput}
							state={editedFatherNameInputState}
							value={editedFatherName}
							onChange={handleFatherNameChange}
							style={{ width: "100%" }}
						/>
						{editedFatherNameError && (
							<div className="text text-body--5 text-left text-danger">{editedFatherNameError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="phonenumber"
							label="public.phonenumber"
							icon={faPhone}
							isMandatory={true}
							placeholder="public.phonenumber.placeholder"
							ref={phoneNumberInput}
							state={editedPhoneNumberInputState}
							value={editedPhoneNumber}
							onChange={handlePhoneNumberChange}
							style={{ width: "100%" }}
						/>
						{editedPhoneNumberError && (
							<div className="text text-body--5 text-left text-danger">{editedPhoneNumberError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="dob"
							type="date"
							label="public.dob"
							icon={faCalendar}
							isMandatory={true}
							placeholder="public.dob.placeholder"
							ref={dobInput}
							state={editedDobInputState}
							onChange={handleDobChange}
							value={moment.unix(editedDob).format("DD/MM/YYYY")}
						/>
						{editedDobError && (
							<div className="text text-body--5 text-left text-danger">{editedDobError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						{genderOptions && (
							<Dropdown
								id="gender"
								label="public.gender"
								icon={faVenusMars}
								isMandatory={true}
								placeholder="public.gender.placeholder"
								ref={genderInput}
								state={editedGenderInputState}
								options={genderOptions}
								onChange={handleGenderInputChange}
								value={editedGender}
							/>
						)}
						{editedGenderError && (
							<div className="text text-body--5 text-left text-danger">{editedGenderError}</div>
						)}
					</div>
				</div>
			</div>

			<div className="divider mt-16 mb-16"></div>

			<div className="row">
				<div className="text text-body--3 text-bold text-left mb-8 popup-section-title">
					{formatMessage({ id: "registration.section.additionalDetails" })}
				</div>
				<div className="row">
					<div className="col-12">
						<Dropdown
							id="anchal"
							label="public.anchal"
							icon={faMapLocation}
							isMandatory={true}
							placeholder="public.anchal.placeholder"
							ref={anchalInput}
							state={editedAnchalInputState}
							options={ANCHAL}
							onChange={handleAnchalChange}
							value={editedAnchal}
						/>
						{editedAnchalError && (
							<div className="text text-body--5 text-left text-danger">{editedAnchalError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="city"
							label="public.city"
							icon={faUser}
							isMandatory={true}
							placeholder="public.city.placeholder"
							ref={cityInput}
							state={editedCityInputState}
							value={editedCity}
							onChange={handleCityChange}
							style={{ width: "100%" }}
						/>
						{editedCityError && (
							<div className="text text-body--5 text-left text-danger">{editedCityError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="state"
							label="public.state"
							icon={faUser}
							isMandatory={true}
							placeholder="public.state.placeholder"
							ref={stateInput}
							state={editedStateInputState}
							value={editedState}
							onChange={handleStateChange}
							style={{ width: "100%" }}
						/>
						{editedStateError && (
							<div className="text text-body--5 text-left text-danger">{editedStateError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="address"
							label="public.address"
							icon={faUser}
							isMandatory={true}
							placeholder="public.address.placeholder"
							ref={addressInput}
							state={editedAddressInputState}
							value={editedAddress}
							onChange={handleAddressChange}
							style={{ width: "100%" }}
						/>
						{editedAddressError && (
							<div className="text text-body--5 text-left text-danger">{editedAddressError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="pincode"
							label="public.pincode"
							icon={faUser}
							isMandatory={true}
							placeholder="public.pincode.placeholder"
							ref={pincodeInput}
							state={editedPincodeInputState}
							value={editedPincode}
							onChange={handlePincodeChange}
							style={{ width: "100%" }}
						/>
						{editedPincodeError && (
							<div className="text text-body--5 text-left text-danger">{editedPincodeError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<Dropdown
							id="education"
							label="public.education"
							icon={faSchool}
							isMandatory={true}
							placeholder="public.education.placeholder"
							ref={educationInput}
							state={editedEducationInputState}
							options={EDUCATION}
							onChange={handleEducationChange}
							value={editedEducation}
						/>
						{editedEducationError && (
							<div className="text text-body--5 text-left text-danger">{editedEducationError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<CustomInput
							id="occupation"
							label="public.occupation"
							icon={faSuitcase}
							isMandatory={true}
							placeholder="public.occupation.placeholder"
							ref={occupationInput}
							state={editedOccupationInputState}
							value={editedOccupation}
							onChange={handleOccupationChange}
							style={{ width: "100%" }}
						/>
						{editedOccupationError && (
							<div className="text text-body--5 text-left text-danger">{editedOccupationError}</div>
						)}
					</div>

					<div className="col-12 mt-16">
						<div className="flex direction-row align-items-center">
							<div className="text text-body--4 text-left">
								{formatMessage({ id: "public.spiritual" })}
							</div>
							<span className="input-mandatory-sign ml-8">*</span>
						</div>
						<div className="col-lg-12 flex direction-row align-items-cente mt-8">
							<Checkbox
								label="public.spiritual.option1"
								state={spiritualLevelState}
								ref={spiritualOptions1Ref}
								onChange={handleSpiritualChange}
							/>
							<Checkbox
								className="ml-16"
								label="public.spiritual.option2"
								state={spiritualLevelState}
								ref={spiritualOptions2Ref}
								onChange={handleSpiritualChange}
							/>
							<Checkbox
								className="ml-16"
								label="public.spiritual.option3"
								state={spiritualLevelState}
								ref={spiritualOptions3Ref}
								onChange={handleSpiritualChange}
							/>
						</div>

						{spiritualLevelError && (
							<div className="text text-body--5 text-left text-danger">{spiritualLevelError}</div>
						)}
					</div>
				</div>
			</div>

			<div className="flex direction-row align-items-center justify-content-end mt-16">
				<Button className="button-tertiary" label="registration.actions.close" onClick={onClose} />
				<Button
					className="button-primary ml-8"
					label="registration.actions.update"
					onClick={onClickUpdateUser}
				/>
			</div>
		</div>
	);
};

export default connect((state) => ({}), { updatedRegisteredUser, fetchRegisteredUsers })(EditUserDetailsPopup);
